<template>
	<div>
		<b-button v-b-toggle="'collapse-doc'">Document</b-button>&nbsp;
		<!-- <b-button @click="generate_images" :disabled="(document && page == 1) ? false : true">Générer les images</b-button>&nbsp; -->
		<b-button @click="reset">Recadrer la vue</b-button>&nbsp;
		<b-button @click="generate">Générer le html</b-button><br /><br />		

		<b-collapse id="collapse-doc">
			<documents
				prop_extension="pdf"
				:select="true"
				:download="false"
				:select_view="false"
				:ref="'doc'"
				@add_file="set_document_ged"></documents>
		</b-collapse>

		<b-form inline>
			<b-input-group prepend="Page">
				<b-select
					v-model="page"
					:options="documents_page.length > 0 ? documents_page : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
				></b-select>
				<b-button @click="zoom(0.8)" variant="link"><i class="fas fa-search-minus"></i></b-button>
				<b-button @click="zoom(1.2)" variant="link"><i class="fas fa-search-plus"></i></b-button>
			</b-input-group>
		</b-form>

		<vue-pdf-embed
			v-show="false"
			@loaded="loaded"
			@rendered="rendered"
			:id="'pdf' + id"
			v-if="document" 
			style="border: solid; "
			:ref="'pdf' + id"
			:page="page"
			:source="document"
			:scale=2 />

		<b-container
			style="
				margin: 0px !important;
				padding: 0px !important;
				max-width: none !important;
			">
			<b-row>
				<b-col>
					<div ref="panzoomElem">
						<panZoom
							selector=".movable"
							style="border: 1px solid; overflow: hidden; background-color:lightgray"
							:options="{
								initialZoom: 0.70,
								bounds: false,
								beforeWheel: function(e) {
									var shouldIgnore = !e.altKey;
									return shouldIgnore;
								},
								zoomDoubleClickSpeed: 1
							}"
							@init="onInit">
							<div
								style="height: 90vh; width: 1px"
								@mousemove="handler_move($event)"
								@mouseup.right="handler_up($event)"
								@mousedown.right="handler($event)"
								@contextmenu.prevent>
								<div class="movable">
									<div v-if="!(image && view_image == 'oui')" style="top: 0px; left: 0px; width:1000000px; height: 1000000px; background-color: white">
									</div>
									<img
										v-if="image && view_image == 'oui'"
										:src="
											image
										" /><img />
									<div
										:style="
											'position:fixed; top:' +
											abs_y +
											'px; left:' +
											(abs_x - 5) +
											'px; height: 1px; width: 11px; background-color: red;'
										"></div>
									<div
										:style="
											'position:fixed; top:' +
											(abs_y - 5) +
											'px; left:' +
											abs_x +
											'px; height: 11px; width: 1px; background-color: red;'
										"></div>
									<div v-for="(zone, idx) in zones" :key="idx">
										<div v-if="zone.page == page && zone.height != 0 && zone.width != 0"
											:style="
												'position:fixed; top:' +
												(zone.y - 6) +
												'px; left:' +
												(zone.x - 6) +
												'px; width: ' +
												(zone.width + 12) +
												'px; height: ' +
												(zone.height + 12) +
												'px;' +
												'border: 6px solid ' + (idx == select ? 'rgb(255,0,0,0.25)' : 'rgb(0,0,255,0.0)') + ';'
											">
											<div style="height:100%; width: 100%" @mouseover="(idx == select) ? mouseOverElem() : ''" @mouseleave="(idx == select) ? mouseLeaveElem() : ''" >
												<div v-html="generate_elem(zone, idx, true)"></div>
											</div>
										</div>
										<div v-if="zone.page == page && zone.height != 0 && zone.width != 0 && idx == select" 
											@mouseover="(idx == select) ? mouseOverDiv('x', 'y', 'nw-resize	') : ''"
											@mouseleave="(idx == select) ? mouseLeaveDiv() : ''" 
											:style="'position:fixed; background-color: rgb(255,0,0,1); ' +
												'top:'+
												(zone.y - 8) +
												'px; left:' +
												(zone.x - 8) +
												'px; width: ' +
												(16) +
												'px; height: ' +
												(16) + 'px;'
											"></div>
										<div v-if="zone.page == page && zone.height != 0 && zone.width != 0 && idx == select" 
											@mouseover="(idx == select) ? mouseOverDiv('x', 'height', 'sw-resize	') : ''"
											@mouseleave="(idx == select) ? mouseLeaveDiv() : ''" 
											:style="'position:fixed; background-color: rgb(255,0,0,1); ' +
												'top:'+
												(zone.y + zone.height - 8) +
												'px; left:' +
												(zone.x - 8) +
												'px; width: ' +
												(16) +
												'px; height: ' +
												(16) + 'px;'
											"></div>
										<div v-if="zone.page == page && zone.height != 0 && zone.width != 0 && idx == select" 
											@mouseover="(idx == select) ? mouseOverDiv('width', 'y', 'ne-resize	') : ''"
											@mouseleave="(idx == select) ? mouseLeaveDiv() : ''" 
											:style="'position:fixed; background-color: rgb(255,0,0,1); ' +
												'top:'+
												(zone.y - 8) +
												'px; left:' +
												(zone.x + zone.width - 8) +
												'px; width: ' +
												(16) +
												'px; height: ' +
												(16) + 'px;'
											"></div>
										<div v-if="zone.page == page && zone.height != 0 && zone.width != 0 && idx == select" 
											@mouseover="(idx == select) ? mouseOverDiv('width', 'height', 'se-resize	') : ''"
											@mouseleave="(idx == select) ? mouseLeaveDiv() : ''" 
											:style="'position:fixed; background-color: rgb(255,0,0,1); ' +
												'top:'+
												(zone.y + zone.height - 8) +
												'px; left:' +
												(zone.x + zone.width - 8) +
												'px; width: ' +
												(16) +
												'px; height: ' +
												(16) + 'px;'
											"></div>
									</div>
								</div>
							</div>
						</panZoom>
					</div>
				</b-col>
				<b-col cols="auto" style="max-width: 30%" class="max-h-[75vh] overflow-y-scroll">
					<h3>Coordonnées</h3>
					<div>
						Coordonnées actuelles<br />
						X : {{ actual_x }} - Y : {{ actual_y }}
					</div>
					<h3>Zones</h3>
					<div>
						<draggable
							group="zones"
							:list="zones"
							class="list-group">
							<div v-for="(zone, idx) in zones" :key="idx">
								<div v-if="zone.page == page">
									<p>
										<span :style="'font-weight:' + (idx == select ? 'bold' : 'normal')">{{(zone.options && zone.options.name && zone.name.startsWith("Zone ")) ? zone.options.name : zone.name}}</span> 
										<b-button @click="change_select(idx)" variant="link"><i class="fas fa-eye"></i></b-button>
										<b-button v-if="zone.delete != false" @click="del(idx)" variant="link"><i class="fas fa-trash"></i></b-button>
										<b-button @click="duplicate(idx)" variant="link"><i class="fas fa-clone"></i></b-button>
									</p>
								</div>
							</div>
						</draggable>
						<b-button variant="link" @click="add"><i class="fas fa-plus"></i></b-button>
					</div>
				</b-col>
			</b-row>
		</b-container>
		<b-container
			style="
				margin: 0px !important;
				padding: 0px !important;
				max-width: none !important;
			">
			<h3 v-if="select > -1">Paramètres</h3>
			<b-row v-if="select > -1">
				<b-col cols="6">
					<div>
						<div>Nom de la zone</div>
						<b-input v-model="zones[select].name"></b-input>
						<div>Page</div>
						<b-input type="number" v-model.number="zones[select].page"></b-input>
						<b-container>
							<b-row>
								<b-col style="margin: 0; padding: 0; max-width: none;">
									<div>Position x</div>
									<b-input type="number" v-model.number="zones[select].x"></b-input>
								</b-col>
								<b-col style="margin: 0; padding: 0; max-width: none;">
									<div>Position y</div>
									<b-input type="number" v-model.number="zones[select].y"></b-input>
								</b-col>
							</b-row>
							<b-row>
								<b-col style="margin: 0; padding: 0; max-width: none;">
									<div>Largeur</div>
									<b-input type="number" v-model.number="zones[select].width"></b-input>
								</b-col>
								<b-col style="margin: 0; padding: 0; max-width: none;">
									<div>Hauteur</div>
									<b-input type="number" v-model.number="zones[select].height"></b-input>
								</b-col>
							</b-row>
						</b-container>
						<div>Taille du texte</div>
						<b-input v-model="zones[select].font_size"></b-input>
						<div>Couleur du texte</div>
						<b-input v-model="zones[select].color"></b-input>
						<div>Couleur de fond</div>
						<b-input v-model="zones[select].background_color"></b-input>
						<div>Classes supplémentaires</div>
						<b-input v-model="zones[select].classes"></b-input>
					</div>
				</b-col>
				<b-col cols="6">
					<div>Type</div>
						<b-select @change="change_type" v-model="zones[select].type" :options="[
                                { value: 'input', text: 'Champ' },
                                { value: 'list', text: 'Liste' },
                                { value: 'textarea', text: 'Zone de texte' },
                                { value: 'text', text: 'Texte' },
								{ value: 'button', text: 'Bouton'},
								{ value: 'html', text: 'HTML'},
							]"></b-select>
						<div v-if="zones[select].type == 'text'">
							<div>Texte</div>
							<b-textarea v-model="zones[select].options.text"></b-textarea>
						</div>
						<div v-if="zones[select].type == 'html'">
							<div>HTML</div>
							<b-textarea v-model="zones[select].options.html"></b-textarea>
						</div>
						<div v-if="zones[select].type == 'input'">
							<div>Type de champ</div>
							<b-select v-model="zones[select].options.type" :options='["", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "month", "number", "password", "radio", "range", "tel", "text", "time", "url", "week"]'></b-select>
							<div>Obligatoire</div>
							<b-checkbox v-model="zones[select].options.required"></b-checkbox>
							<div>Colonne de sortie</div>
							<b-input v-model="zones[select].options.name"></b-input>
							<div v-if="zones[select].options.type == 'radio'">
								<div>Valeur du bouton radio</div>
								<b-input v-model="zones[select].options.value"></b-input>
								<div>Coché par defaut</div>
								<b-checkbox v-model="zones[select].options.checked"></b-checkbox>
							</div>
							<div v-else-if="zones[select].options.type == 'checkbox'">
								<div>Coché par defaut</div>
								<b-checkbox v-model="zones[select].options.checked"></b-checkbox>
							</div>
							<div v-else>
								<div>Valeur par defaut</div>
								<b-input v-model="zones[select].options.value"></b-input>
								<div>Description</div>
								<b-input v-model="zones[select].options.placeholder"></b-input>
								<div>Liste de suggestions</div>
								<b-checkbox v-model="zones[select].options.list"></b-checkbox>
								<div v-if="zones[select].options.list">
									<div>Liste - un élément par ligne</div>
									<b-textarea rows="10" v-model="zones[select].options.list_items"></b-textarea>
								</div>
							</div>
							<div>Options suplémentaires</div>
							<b-input v-model="zones[select].options.options"></b-input>
						</div>
						<div v-if="zones[select].type == 'list'">
							<div>Obligatoire</div>
							<b-checkbox v-model="zones[select].options.required"></b-checkbox>
							<div>Colonne de sortie</div>
							<b-input v-model="zones[select].options.name"></b-input>
							<div>Valeur par defaut</div>
							<b-input v-model="zones[select].options.value"></b-input>
							<b-container 
								style="
									margin: 0px !important;
									padding: 0px !important;
									max-width: none !important;
								">
								<b-row>
									<b-col cols="6">
										<div>Liste - libellés</div>
										<b-textarea rows="3" v-model="zones[select].options.list_items"></b-textarea>
									</b-col>
									<b-col cols="6">
										<div>Liste - valeurs</div>
										<b-textarea rows="3" v-model="zones[select].options.list_values"></b-textarea>
									</b-col>
								</b-row>
							</b-container>
							<p>Vue</p>
							<DatabaseRequestView :minimal="true" :ref="'view'" :form="true"/>
							<div>Colonne des libellés</div>
							<b-input v-model="zones[select].options.column_items"></b-input>
							<div>Colonne des valeurs</div>
							<b-input v-model="zones[select].options.column_values"></b-input>
							<div>Options suplémentaires</div>
							<b-input v-model="zones[select].options.options"></b-input>
						</div>
						<div v-if="zones[select].type == 'textarea'">
							<div>Obligatoire</div>
							<b-checkbox v-model="zones[select].options.required"></b-checkbox>
							<div>Colonne de sortie</div>
							<b-input v-model="zones[select].options.name"></b-input>
							<div>Valeur par defaut</div>
							<b-textarea v-model="zones[select].options.value"></b-textarea>
							<div>Texte indicatif</div>
							<b-textarea v-model="zones[select].options.placeholder"></b-textarea>
							<div>Options suplémentaires</div>
							<b-input v-model="zones[select].options.options"></b-input>
						</div>
						<div v-if="zones[select].type == 'button'">
							<div>Action</div>
							<b-select v-model="zones[select].options.action" :options="[
                                { value: 'send', text: 'Envoyer' },
                                { value: 'prev_page', text: 'Page précédente' },
								{ value: 'next_page', text: 'Page suivante'}
							]"></b-select>
							<div>Texte</div>
							<b-input v-model="zones[select].options.text"></b-input>
						</div>
				</b-col>
			</b-row>
		</b-container>
		<hr />
		<b-button @click="generate">Générer le html</b-button>
		<br /><br />
	</div>
</template>

<script>
	import draggable from "vuedraggable";
	import uniqueId from "lodash.uniqueid";
	import { JSONEditor } from "@json-editor/json-editor";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";
	import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

	import store from "../store";
	import library from "../services/library.js";
	import workers from "../services/workers.js";
	import documents from "../views/Document.vue";
	import treatments from "../services/treatments.js";
	import document_service from "../services/document.js";
	import edit_tabulator from "../components/edit_tabulator.vue";
	import DatabaseRequestView from "../views/DatabaseRequestView.vue";
	import document_extraction_zone from "../components/document_extraction_zone.vue";
	import document_extraction_tree from "../components/document_extraction_tree.vue";


	var clone = require("clone");

	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	export default {
		name: "zones_form",
		components: {
			draggable,
			FadeLoader,
			edit_tabulator,
			VuePdfEmbed,
			documents,
			DatabaseRequestView
		},
		props: {
			library: {
				default: false
			},
			type_doc: {
				default: ""
			}
		},
		watch:
		{
			zones: {
				deep: true,
				handler() {
				}
			}
		},
		data() {
			return {
				id: uniqueId(""),
				relative: false,
				move: false,
				name_zone: "",
				color: "oui",
				view_image: "oui",
				view_text: "oui",
				spinner: false,
				results: {},
				name: "",
				page: 1,
				url_pdf: "",
				url_image: "",
				image: "",
				panzoomInstance: null,
				items: [],
				styles: {},
				target: -1,
				item: null,
				x: 0,
				actual_x: 0,
				y: 0,
				actual_y: 0,
				abs_x: 0,
				abs_actual_x: 0,
				abs_y: 0,
				abs_actual_y: 0,
				e: null,
				zones: [
				],
				zone: null,
				view_zones: "",
				document: {},
				document_page: "",

				document: null,
				documents_page: [],

				select: -1,
				doc_ged: null,

				resolve_generate_images: null,
				images: [],

				mouse_resize: false,
				mouse_resize_x: false,
				mouse_resize_y: false,
				mouse_move: false,

				g_image: false
			};
		},
		methods: {
			generate_elem(zone, i, panzoom, scripts = false)
			{
				var html = "";
				var style = "";
				if (!panzoom)
					style += `position: absolute; left:${zone.x}px; top:${zone.y}px;`;
				else
					style += "cursor: inherit; user-select: none; -moz-user-select: none; -webkit-user-select: none;"
				style += `width:${zone.width}px; color:${zone.color || 'black'};background-color:${zone.background_color || 'white'};font-size:${zone.font_size || '1em'};`;

				if (zone.type == 'list')
				{
					html += `<select ${zone.options.required ? "required" : ""} class="p p${zone.page} ${zone.options.required ? "p" + zone.page + "required" : ""} ${zone.classes || ""}" style="${style}" id="i${i}" name="${zone.options.name ? zone.options.name : zone.name}" ${zone.options.options || ""}
					`;

					if (panzoom)
						html += "disabled";

					html += ">"

					var list = zone.options.list_items.split("\n");
					var list_values = zone.options.list_values.split("\n");
					for (var j = 0; j < list.length; j++)
					{
						html += `	<option value="${(j < list_values.length) ? list_values[j] : list[j]}" ${zone.options.value == ((j < list_values.length) ? list_values[j] : list[j]) ? "selected" : ""}>${list[j]}</option>`
					}

					html += `</select>
					`;

					if (zone.options.view && scripts)
					{
						console.log(zone.options.view)
						this.variables += `
							list_db_${i} = [];						
						`;

						var body = JSON.stringify({request: zone.options.view.request, user_params: zone.options.view.params});
						body = body.replaceAll("${", "c41bd1e2-2c96-4966-8d98-ac0f053f340e");

						this.start += `
							console.log("fetch");
							fetch(host + "/database/request", {
								method: 'POST',
								headers: {
									'Accept': 'application/json',
									'Content-Type': 'application/json',
									'Authorization': 'bearer ' + token
								},
								body: JSON.stringify(${body})
							})
							.then((response) => response.json())
							.then((data) => {
								select = document.getElementById("i${i}");
								data = data.response.data;
								for (var i = 0; i < data.length; i++)
								{ 
									select.options[select.options.length] = new Option(data[i]["${zone.options.column_items}"], data[i]["${zone.options.column_values}"], (data[i]["${zone.options.column_values}"] == "${zone.options.value}") ? true : false, (data[i]["${zone.options.column_values}"] == "${zone.options.value}") ? true : false);
								}
							})
							.catch((error) => console.error(error));
						`;
					}
				}
				else if (zone.type == 'input')
				{
					if (zone.options.type == "checkbox" || zone.options.type == "radio")
						style += `height:${zone.height}px;`
					html += `<input ${zone.options.list ? 'list="i' + i +'list"' : ""} ${zone.options.required ? "required" : ""} ${zone.options.placeholder ? 'placeholder="' + zone.options.placeholder+'"' : ""} class="p p${zone.page} ${zone.options.required ? "p" + zone.page + "required" : ""} ${zone.classes || ""}" style="${style}" type="${zone.options.type || ''}" ${zone.options.value ? 'value="' + (zone.options.value || "") + '"' : ""} ${zone.options.checked ? "checked" : ""} id="i${i}" name="${zone.options.name ? zone.options.name : zone.name}" ${zone.options.options || ""}
					`;

					if (panzoom)
						html += "disabled";

					html += "/>"

					if (zone.options.list && zone.options.list_items)
					{
						html += `<datalist id="i${i}list">
						`;
						var list = zone.options.list_items.split("\n");
						for (var j = 0; j < list.length; j++)
						{
							html += `	<option value="${list[j]}">`
						}
						html += `</datalist>
						`;
					}
				}
				else if (zone.type == 'button')
				{
					style += `height:${zone.height}px;`
					if (zone.options.action == "prev_page")
					{
						html += `<input onclick="add_page(-1)" class="p p${zone.page} ${zone.classes || ""}" style="${style}" type ="button" value="${zone.options.text ? zone.options.text : zone.options.action}"`;
					}
					else if (zone.options.action == "next_page")
					{
						html += `<input onclick="add_page(1)" class="p p${zone.page} ${zone.classes || ""}" style="${style}" type ="button" value="${zone.options.text ? zone.options.text : zone.options.action}"`;
					}
					else
					{
						html += `<input class="p p${zone.page} ${zone.classes || ""}" style="${style}" type="submit" value="${zone.options.text ? zone.options.text : zone.options.action}"`;
					}

					if (panzoom)
						html += "disabled";

					html += `>
					`
				}
				else if (zone.type == 'text')
				{
					style += `height:${zone.height}px;`
					html += `<div class="p p${zone.page} ${zone.classes || ""}" style="${style}">${zone.options.text}</div>
					`;
				}
				else if (zone.type == 'textarea')
				{
					style += `height:${zone.height}px;`
					html += `<textarea ${panzoom ? "disabled" : ""} ${zone.options.required ? "required" : ""} ${zone.options.placeholder ? 'placeholder="' + zone.options.placeholder+'"' : ""} class="p p${zone.page} ${zone.options.required ? "p" + zone.page + "required" : ""} ${zone.classes || ""}" style="${style}" ${zone.options.value ? 'value="' + zone.options.value + '"' : ""} id="i${i}" name="${zone.options.name ? zone.options.name : zone.name}" ${zone.options.options || ""} >${zone.options.value || ""}</textarea>
					`;
				}
				else if (zone.type == 'html')
				{
					style += `height:${zone.height}px;`
					html += `<div class=" ${zone.classes || ""}" style="${style}">${zone.options.html}</div>
					`;
				}

				return html
			},
			async generate()
			{
				if (this.select >= 0 && this.zones[this.select].type == "list")
				{
					this.zones[this.select].options.view = await this.$refs.view.save();
				}

				var html = `<div>
				`;
				this.variables = `
				<script>
				var page = 1;
				var token = document.getElementById("form").getAttribute("token");
				var host = document.getElementById("form").getAttribute("host");

				console.log(token);
				console.log(host);
				`;
				this.script = `

				function set_visibility()
				{
					for (let el of document.getElementsByClassName("p"))
					{
						if (el.classList.contains("p" + page))
						{
							el.style.visibility = 'visible';
						}
						else
						{
							el.style.visibility = 'hidden';
						}
					}
				}

				function add_page(nb)
				{
					var c = true;

					for (let el of document.getElementsByClassName("p" + page + "required"))
					{
						if (!el.checkValidity())
						{
							el.reportValidity();
							c = false;
						}
					}

					if (c)
					{
						page += nb;
						set_visibility();
					}
				}`

				this.start = `document.addEventListener('DOMContentLoaded', (event) => {
					set_visibility();
				`;

				if (this.images.length > 0)
				{
					for (var i = 0; i < this.images.length; i++)
					{
						html += `<img style="position: absolute; left:0px; top:0px" src="${this.images[i]}" class="p p${(i + 1)}" />
						`
					}
				}

				html += `
				`;

				for (var i = 0; i < this.zones.length; i++)
				{
					var zone = this.zones[i];
					html += this.generate_elem(zone, i, false, true);
				}

				var script = this.variables + this.script + this.start + `
				}); 
				<\/script>`;

				html += `</div>`;

				var form = {
					"send": "",
					"title": "",
					"sections": [{
						"title": "",
						"fields": [
							{
								"type": "html",
								"html": html
							}
						]
					}],
					"before_html_2": "",
					"after_html_2": script
				};

				this.$emit("update", form);
			},
			async change_type()
			{
				var zone = this.zones[this.select];

				if (zone.type == "button")
				{
					zone.background_color = "#4CAF50";
					zone.options.action = "send";
				}
				else if (zone.type == "list")
				{
					zone.options.list_items = "";
					zone.options.list_values = "";
				}
			},
			async set_document_ged(doc, load = false)
			{
				console.log("w")

				if (load == false)
					this.g_image = true;

				this.doc_ged = doc;

				doc = await document_service.getFile(doc.uid, doc.libelle, false, "blob", doc.share);
				await this.setDocument(doc);

				if (this.type_doc && this.doc_ged[this.type_doc])
				{
					if (this.types.includes(this.doc_ged[this.type_doc]))
					{
						this.type = this.doc_ged[this.type_doc];
						this.change_type(this.doc_ged[this.type_doc]);
					}
				}
			},
			async load(data)
			{
				console.log(data)
				this.images = data.images || [];
				this.zones = data.zones;
				this.doc_ged = data.doc;

				if (this.doc_ged)
					this.set_document_ged(this.doc_ged, true);
			},
			async save()
			{
				if (this.select >= 0 && this.zones[this.select].type == "list")
				{
					this.zones[this.select].options.view = await this.$refs.view.save();
				}
				
				return {
					zones: this.zones,
					doc: this.doc_ged,
					data: this.get_data(),
					images: this.images
				}
			},
			async new() {
			},
			get_data()
			{
				var data = [];

				for (var i = 0; i < this.zones.length; i++)
				{
					var zone = {};
					zone.positionX = this.zones[i].x;
					zone.positionY = this.zones[i].y;
					zone.page = this.zones[i].page;

					data.push(zone);
				}

				return data;
			},
			async change_select(idx)
			{
				var self = this;

				if (this.select >= 0 && this.zones[this.select].type == "list")
				{
					this.zones[this.select].options.view = await this.$refs.view.save();
				}

				this.select = idx;

				if (this.zones[this.select].type == "list" && this.zones[this.select].options.view)
				{
					self.$nextTick(async function () {
						self.$refs.view.load(self.zones[self.select].options.view);
					});
				}
			},
			add()
			{
				this.zones.push({
					uid: uniqueId(""),
					x: 0,
					y: 0,
					width: 0, //200,
					height: 0, //25,
					type: "input",
					name: "Zone " + (this.zones.length + 1),
					font_size: "1em",
					background_color: "white",
					color: "black",
					classes: "",
					options: {
						list_items: "",
						list_values: ""
					},
					delete: true,
					page: this.page
				})

				this.select = this.zones.length - 1;
			},
			duplicate(idx)
			{
				var zone = clone(this.zones[idx]);
				zone.name += " - copy";
				this.zones.push(zone)

				this.select = this.zones.length - 1;
			},
            del(idx)
            {
				this.zones.splice(idx, 1);
				
				/*if (this.select >= this.zones.length)
					this.select = this.zones.length - 1;*/

				this.select = -1;
				this.move = false;
				this.mouse_resize = false;
				this.mouse_x = false;
				this.mouse_y = false;
				this.mouse_move = false;
				document.body.style.cursor = 'auto';
			},
			async generate_images()
			{
				console.log("generate_images")
				console.log(this.documents_page)

				var base_name = this.doc_ged.libelle.replace(/\.[^.]*$/, "");
				const formData = new FormData();
				formData.append("folder", this.doc_ged.folder);
				formData.append("public", "true");

				console.log(this.image)
				var file = await fetch(this.image)
				file = await file.blob();
				formData.append(base_name + "-1.png", file, base_name + "-1.png");

				var self = this;
				for (var i = 1; i < this.documents_page.length; i++)
				{
					console.log(i)
					await new Promise((resolve, reject) => {
						self.resolve_generate_images = resolve;
						self.page++;
					});
					console.log(this.image)
					var file = await fetch(this.image)
					file = await file.blob();
					formData.append(base_name + "-" + (i + 1) + ".png", file, base_name + "-" + (i + 1) + ".png");
				}
				this.page = 1;

				var files = await document_service.add_files(formData);
				files = files.add_file;
				console.log(files);
				this.images = [];
				for (var i = 0; i < files.length; i++)
				{
					this.images.push(files[i].url);
				}

				console.log("end generate")

				this.generate();
			},
			async loaded(data)
			{
				var self = this;
				console.log(data._pdfInfo.numPages)

				this.documents_page = [];
				for (var i = 0; i < data._pdfInfo.numPages; i++)
				{
					this.documents_page.push(i + 1);
				}
			},
			rendered()
			{
				console.log("rendered");
				var self = this;
				let s = document.querySelectorAll('#pdf' + this.id + ' canvas')[0]
				console.log(s)

				this.image = s.toDataURL('img/png');

				var i = new Image();

				i.onload = function(){
					self.image_width = i.width;
					self.image_height = i.height;
				};

				i.src = this.image;

				console.log("this.resolve_generate_images")
				if (this.resolve_generate_images)
				{
					console.log("resolve generate_images")
					this.resolve_generate_images();
					this.resolve_generate_images = null;
				}

				if (this.g_image)
				{
					this.generate_images()
					this.g_image = false;
				}
			},
			_arrayBufferToBase64(buffer) {
				var binary = "";
				var bytes = new Uint8Array(buffer);
				var len = bytes.byteLength;
				for (var i = 0; i < len; i++) {
					binary += String.fromCharCode(bytes[i]);
				}
				return window.btoa(binary);
			},
			setDocument: async function (document) {

				if (document)
				{
					var self = this;
					let reader = new FileReader();

					reader.onload = function(e) {
						self.document = new Uint8Array(reader.result);
						console.log(self.document);
					}

					reader.readAsArrayBuffer(document);
				}
			},
			addClass: function (e) {
				this.target = e.target.id;
				e.target.classList.add("hovered");
			},
			removeClass: function (e) {
				this.target = -1;
				e.target.classList.remove("hovered");
			},
			setMeta(name, page, url_pdf) {
				this.name = name;
				this.page = page;
				this.url_pdf = url_pdf;
			},
			setItems(items) {
				this.items = items;
			},
			setStyle(styles) {
				this.styles = styles;
			},
			zoom(value)
			{
				var pos = this.panzoomInstance.getTransform();
				var cx = this.$refs.panzoomElem.getBoundingClientRect().x +  this.$refs.panzoomElem.getBoundingClientRect().width/2;
				var cy = this.$refs.panzoomElem.getBoundingClientRect().y +  this.$refs.panzoomElem.getBoundingClientRect().height/2;

				this.panzoomInstance.smoothZoom(cx, cy, value);
			},
			reset() {
				this.panzoomInstance.zoomAbs(0, 0, 0.70);
				this.panzoomInstance.moveTo(0, 0);
			},
			onInit: function (panzoomInstance, id) {
				this.panzoomInstance = panzoomInstance;
				this.panzoomInstance.zoomAbs(0, 0, 0.70);
				this.panzoomInstance.moveTo(0, 0);
			},
			handler_up: function (e) {
				var left =
					e.clientX -
					this.$refs.panzoomElem.getBoundingClientRect().left;
				var top =
					e.clientY -
					this.$refs.panzoomElem.getBoundingClientRect().top;
				var pos = this.panzoomInstance.getTransform();
				left = (left / pos.scale - pos.x / pos.scale) * 1;
				top = (top / pos.scale - pos.y / pos.scale) * 1;
				var x = Math.round(left);
				var y = Math.round(top);

				if (this.move) {
					var x1 = 0;
					var x2 = 0;
					var y1 = 0;
					var y2 = 0;
					if (this.x > x) {
						x1 = x;
						x2 = this.x;
					} else {
						x1 = this.x;
						x2 = x;
					}
					if (this.y > y) {
						y1 = y;
						y2 = this.y;
					} else {
						y1 = this.y;
						y2 = y;
					}

					if (this.select > -1)
					{
						if (this.zones[this.select].height == 0 && this.zones[this.select].width == 0)
						{
							this.zones[this.select].x = x1;
							this.zones[this.select].width = x2 - x1;
							this.zones[this.select].y = y1;
							this.zones[this.select].height = y2 - y1;
							this.zones[this.select].page = this.page;

							if (!this.zones[this.select].width)
								this.zones[this.select].width = 200;
							if (!this.zones[this.select].height)
								this.zones[this.select].height = 30;
						}
					}
				}
				if (this.move)
				{
					this.move = false;
					this.mouse_resize = false;
					this.mouse_resize_x = false;
					this.mouse_resize_y = false;
					this.mouse_move = false;
				}
			},
			handler_move: function (e) {
				var left =
					e.clientX -
					this.$refs.panzoomElem.getBoundingClientRect().left;
				var top =
					e.clientY -
					this.$refs.panzoomElem.getBoundingClientRect().top;
				var pos = this.panzoomInstance.getTransform();
				left = (left / pos.scale - pos.x / pos.scale) * 1;
				top = (top / pos.scale - pos.y / pos.scale) * 1;
				this.prev_x = this.actual_x;
				this.actual_x = Math.round(left);
				this.abs_actual_x = this.actual_x;
				this.prev_y = this.actual_y;
				this.actual_y = Math.round(top);
				this.abs_actual_y = this.actual_y;

				if (this.move)
				{
					var x = Math.round(left);
					var y = Math.round(top);
					if (x != this.x && y != this.y) {
						var x1 = 0;
						var x2 = 0;
						var y1 = 0;
						var y2 = 0;
						if (this.x > x) {
							x1 = x;
							x2 = this.x;
						} else {
							x1 = this.x;
							x2 = x;
						}
						if (this.y > y) {
							y1 = y;
							y2 = this.y;
						} else {
							y1 = this.y;
							y2 = y;
						}

						if (this.select > -1)
						{
							if ((this.mouse_resize && !this.mouse_move) || (this.zones[this.select].height == 0 && this.zones[this.select].width == 0))
							{
								this.zones[this.select].x = x1;
								this.zones[this.select].width = x2 - x1;
								this.zones[this.select].y = y1;
								this.zones[this.select].height = y2 - y1;
							}
							else if (this.mouse_move)
							{
								this.zones[this.select].x += (this.actual_x - this.prev_x);
								this.zones[this.select].y += (this.actual_y - this.prev_y);
							}
							if (this.mouse_resize_x == "x")
							{
								var right = this.zones[this.select].x + this.zones[this.select].width;
								if (x < right)
								{
									this.zones[this.select].x = x;
									this.zones[this.select].width = right - this.zones[this.select].x;
								}
							}
							if (this.mouse_resize_x == "width")
							{
								if (this.actual_x > this.zones[this.select].x)
								{
									this.zones[this.select].width = this.actual_x - this.zones[this.select].x;
								}
							}
							if (this.mouse_resize_y == "y")
							{
								var bottom = this.zones[this.select].y + this.zones[this.select].height;
								if (y < bottom)
								{
									this.zones[this.select].y = y;
									this.zones[this.select].height = bottom - this.zones[this.select].y;
								}
							}
							if (this.mouse_resize_y == "height")
							{
								if (this.actual_y > this.zones[this.select].y)
								{
									this.zones[this.select].height = this.actual_y - this.zones[this.select].y;
								}
							}
						}
					}
				}
			},
			handler: function (e) {
				var left =
					e.clientX -
					this.$refs.panzoomElem.getBoundingClientRect().left;
				var top =
					e.clientY -
					this.$refs.panzoomElem.getBoundingClientRect().top;
				var pos = this.panzoomInstance.getTransform();
				left = (left / pos.scale - pos.x / pos.scale) * 1;
				top = (top / pos.scale - pos.y / pos.scale) * 1;
				this.x = Math.round(left);
				this.abs_x = this.x;
				this.y = Math.round(top);
				this.abs_y = this.y;
				if (this.e) this.e.target.classList.remove("selected");
				if (this.target > -1) {
					this.item = this.items[this.target];
					this.e = e;
					e.target.classList.add("selected");
				} else {
					this.e = null;
					this.item = null;
				}

				if (this.select > -1)
				{
					this.move = true
					console.log("start move " + this.mouse_resize_x + " " + this.mouse_resize_y)
					if (this.zones[this.select].height == 0 && this.zones[this.select].width == 0)
					{
						this.zones[this.select].x = this.x;
						this.zones[this.select].y = this.y;
						this.zones[this.select].page = this.page;
						this.mouse_resize = true;
					}
				}
			},
			mouseOverDiv(x, y, cursor)
			{
				console.log("mouseOver div ")
				if (!this.mouse_move && !this.move)
				{
					document.body.style.cursor = cursor;
					this.mouse_resize_x = x;
					this.mouse_resize_y = y;
					console.log("resize " + this.mouse_resize_x + " " + this.mouse_resize_y)
				}
			},
			mouseLeaveDiv()
			{
				console.log("mouseLeave div ")
				if (!this.mouse_move && !this.move)
				{
					console.log("leave")
					this.mouse_resize_x = false;
					this.mouse_resize_y = false;
					document.body.style.cursor = 'auto';
				}
			},
			mouseOverElem()
			{
				console.log("mouseOver")
				if (!this.move)
				{
					this.mouse_move = true;
					document.body.style.cursor = 'move';
				}
			},
			mouseLeaveElem()
			{
				console.log("mouseLeave")
				if (!this.move)
				{
					this.mouse_move = false;
					document.body.style.cursor = 'auto';
				}
			}
		},
		mounted: async function () {
		},
	};
</script>

<style>
	.hovered {
		text-decoration: underline blue;
		cursor: crosshair;
	}
	.selected {
		text-decoration: underline red;
		cursor: crosshair;
	}
	input:disabled{ pointer-events: none; }
</style>
